import { Directive, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[appPhoneMask]'
})
export class PhoneMaskDirective {
  constructor(public ngModel: NgModel) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }

  onInputChange(event, backspace) {
    if (event != undefined) {
      let v = event.replace(/\D/g, '');
      v = v.replace(/^(\d\d)(\d)/g, '($1) $2');

      if (v.length < 14) {
        v = v.replace(/(\d{4})(\d)/, '$1-$2');
      } else {
        v = v.replace(/(\d{5})(\d)/, '$1-$2');
      }

      this.ngModel.valueAccessor.writeValue(v);
    }
  }
}


// WEBPACK FOOTER //
// D:/Agents/amapa/_work/8/s/ANGULAR/src/app/shared/directive/phone-mask.directive.ts.ts